(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-html"] && !Shopify.designMode) return;
  try {
    


var feefocontainer = document.getElementById("feefo-product-review-widgetId");
if(typeof(feefocontainer) != 'undefined' && feefocontainer != null){
	var feefosection = document.getElementById("feefo-section");
	if(typeof(feefosection) != 'undefined' && feefosection != null){
		feefocontainer.setAttribute('data-parent-product-sku', feefosection.getAttribute('data-sku') );
  	}
}




  } catch(e) { console.error(e); }
})();
})();
